<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme
    },
  },
  created() {
    const bodyTag = document.querySelector('body')
    if (!bodyTag) {
      return
    }
    bodyTag.className = this.currentTheme
  },
}
</script>
